export default __webpack_public_path__ + "static/media/pt.8251fd68.svg";